import React from 'react'

import { Close, ExpandMore } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { Grid, TextField } from '@material-ui/core';

export const SuperUserDropdown = ({
    stateOpen = false,
    localStorageSetItem = undefined,
    localStorageRemoveItem = undefined,
    SetHeaderButtons =undefined,
    setState = undefined,
    communityData = [],
    superUserCommunitySelected = {},
    GetCategories = undefined,
    FilterActivitiesByDate = undefined,
    dispatchActions = undefined,
    showLabel = false,
    label,
    input,
    disabled,
    error = undefined,
    helperText = undefined,
    onBlur,
    autoFocus,
    idToSet = 'SuperUserComboV2',
}) => {

    return (
        <>
            <Autocomplete
                id={idToSet ? idToSet : 'SuperUserComboV2'}
                disableClearable
                style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px', }}
                options={communityData}
                value={superUserCommunitySelected? superUserCommunitySelected :{}}
                disabled={disabled ? disabled : false}
                classes={{
                    option: "MuiAutocomplete-option-community",
                }}
                getOptionSelected={(option, value) => option === value ? true : false}
                getOptionLabel={option => option.name ? option.name : ''}
                renderOption={option => {
                    return (
                        <Grid id={`option_${option.indexForCombo}`} item container alignItems='center' className={(!option.indexForCombo) ? "optionRow" : (option.indexForCombo % 2 === 0) ? "optionRow" : "optionRowEven"}>
                            <Grid item style={{color:'black'}}>{option.name}</Grid>
                        </Grid>
                    )
                }}
                onChange={(evet, newItem) => 
                    {   
                        if(newItem !== null && newItem !== ''){ 

                            if(localStorageSetItem){
                                localStorageSetItem('communityId',newItem.communityId)
                            }
                        
                            let objToSet = undefined;
                            if(FilterActivitiesByDate){
                                objToSet ={
                                    CommunitySelected :newItem,
                                    filterObj:{}
                                }
                            }else{
                                objToSet ={
                                    superUserCommunitySelected :newItem,
                                }
                            }

                            if(setState)
                                setState(objToSet)
                                
                        } else{

                            if(localStorageRemoveItem)
                                localStorageRemoveItem('communityId')
                             
                                let objToSet = undefined;
                                if(FilterActivitiesByDate){
                                    objToSet ={
                                        CommunitySelected :undefined,
                                        filterObj:{}
                                    }
                                }else{
                                    objToSet ={
                                        superUserCommunitySelected :undefined,
                                    }
                                }

                            if(setState)
                                setState(objToSet)

                        
                        }
                        
                        if(SetHeaderButtons)
                            SetHeaderButtons(stateOpen)

                        if(GetCategories)
                            GetCategories()

                        if(FilterActivitiesByDate)
                            FilterActivitiesByDate(0,newItem)
                        if(dispatchActions){
                            dispatchActions()
                        }
                    }
                }
                renderInput={(params) => {
                    return (
                        <TextField
                            {...params}
                            {...input}
                            error={error ? error : undefined}
                            helperText={helperText ? helperText : undefined}
                            onBlur={onBlur}
                            autoFocus={autoFocus}
                            label={showLabel ? label : undefined}
                            InputProps={{ ...params.InputProps, classes:{input:'txt_black'} }}

                        />
                    )
                }}
                popupIcon={
                    <ExpandMore style={{ color: 'black' }} />
                }
                closeIcon={
                    <Close fontSize="small" style={{ color: 'black' }} />
                }
            />
        </>
    )
}
